/**
 * A downloaded HTML file carries no stylesheet, so its images are drawn at their natural size and a
 * picture wider than the browser window pushes the whole page sideways (the GIGA screen and the
 * editor scale images with their own CSS).
 */

// In a cascade layer these rules lose to every style the content brings itself (inline styles, the
// CSS of a landing page or of a custom HTML block), so they only size images nothing else sizes. The
// height follows the width where width and height attributes would squash a narrowed image.
const FIT_IMAGES_CSS = '@layer download-defaults{img{max-width:100%}img[width][height]{height:auto}}';

/**
 * Keeps the images of a downloaded HTML file within the page width. The style goes at the end: the
 * download is a body fragment, and a style at its start is moved out of the body (and dropped) when
 * the HTML is parsed again on its way to the file.
 */
export const fitImagesToPageWidth = (html: string): string =>
  html && /<img[\s/>]/i.test(html) ? `${html}<style>${FIT_IMAGES_CSS}</style>` : html;
